"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBillDetails = exports.fetchDownloadReport = exports.fetchPaymentwiseReport = exports.fetchDuplicateBillReport = exports.fetchWriteOffReport = exports.fetchCounterWiseReport = exports.fetchUserwiseReport = exports.fetchInventoryReport = exports.fetchItemWiseReport = exports.fetchDaywiseReport = exports.fetchBillwiseReport = exports.fetchOutletwiseSummaryForOutlet = exports.fetchOutletwiseSummaryForFranchise = exports.fetchOutletwiseSummary = exports.fetchOutletSummary = exports.fetchBusinessSummary = exports.fetchBusinessSummaryCurrent = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const reportsService_1 = require("./service/reportsService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetchBusinessSummaryCurrent = (0, toolkit_1.createAsyncThunk)('reports/fetchBusinessSummaryCurrent', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchBusinessSumary(fetchPayload !== null && fetchPayload !== void 0 ? fetchPayload : {});
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchBusinessSummary = (0, toolkit_1.createAsyncThunk)('reports/fetchBusinessSummary', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchBusinessSumary(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchOutletSummary = (0, toolkit_1.createAsyncThunk)('reports/fetchOutletSummary', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchOutletSummary(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchOutletwiseSummary = (0, toolkit_1.createAsyncThunk)('reports/fetchOutletwiseSummary', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchOutletwiseSummary(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchOutletwiseSummaryForFranchise = (0, toolkit_1.createAsyncThunk)('reports/fetchOutletwiseSummaryForFranchise', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchOutletwiseSummaryForFranchise(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchOutletwiseSummaryForOutlet = (0, toolkit_1.createAsyncThunk)('reports/fetchOutletwiseSummaryForOutlet', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchOutletwiseSummaryForFranchise(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchBillwiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchBillwiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchBillwiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchDaywiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchDaywiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchDaywiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchItemWiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchItemWiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchItemWiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchInventoryReport = (0, toolkit_1.createAsyncThunk)('reports/fetchInventoryReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchInventoryReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchUserwiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchUserwiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchUserwiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchCounterWiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchCounterWiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchCounterWiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchWriteOffReport = (0, toolkit_1.createAsyncThunk)('reports/fetchWriteOffReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchWriteOffReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchDuplicateBillReport = (0, toolkit_1.createAsyncThunk)('reports/fetchDuplicateBillReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchDuplicateBillReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchPaymentwiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchPaymentwiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchPaymentwiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchDownloadReport = (0, toolkit_1.createAsyncThunk)('reports/fetchDownloadReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.downloadReports(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchBillDetails = (0, toolkit_1.createAsyncThunk)('reports/fetchBillDetails', (billId, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchBillDetails(billId);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch bill details');
    }
}));
exports.fetchWaiterItemWiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchWaiterItemWiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchWaiterItemWiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchWaiterCommissionReport = (0, toolkit_1.createAsyncThunk)('reports/fetchWaiterCommissionReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchWaiterCommissionReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchWaiterMonthWiseReport = (0, toolkit_1.createAsyncThunk)('reports/fetchWaiterMonthWiseReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchWaiterMonthWiseReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
exports.fetchWaiterSalesReport = (0, toolkit_1.createAsyncThunk)('reports/fetchWaiterSalesReport', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const reportsService = new reportsService_1.ReportService(Env_1.APIPATHENV);
        const response = yield reportsService.fetchWaiterSalesReport(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch reports');
    }
}));
